import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

const refreshTokenMutation = () => useMutation({
  mutationKey: ['refreshToken'],
  mutationFn: (refreshToken: string) => axios.post(import.meta.env.VITE_APP_BASE_URL + '/auth/refresh', null, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${refreshToken}`,
    },
  }),
});

export default refreshTokenMutation;
